import { render, staticRenderFns } from "./MapModal.vue?vue&type=template&id=28bd0856&scoped=true"
import script from "./MapModal.vue?vue&type=script&lang=js"
export * from "./MapModal.vue?vue&type=script&lang=js"
import style0 from "./MapModal.vue?vue&type=style&index=0&id=28bd0856&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28bd0856",
  null
  
)

export default component.exports